import { createGlobalStyle } from "styled-components";
import ParisienneRegular from "../assets/fonts/Parisienne-Regular.ttf";

export const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Crimson+Text:ital,wght@0,400;0,600;0,700;1,400&family=Playfair+Display:ital,wght@0,400;0,700;0,900;1,400&family=DM+Serif+Display&family=Lora:ital,wght@0,400;0,600;0,700;1,400&family=Merriweather:ital,wght@0,300;0,400;0,700;1,300&family=EB+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Source+Serif+Pro:ital,wght@0,400;0,600;0,700;1,400&display=swap');

  @font-face {
    font-family: 'Parisienne';
    src: url(${ParisienneRegular}) format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    max-width: 100vw;
  }

  :root {
    --color-text: #2D1B3D;
    --color-text-light: #6B4E71;
    --color-bg: #FEF7FE;
    --color-white: #ffffff;
    --color-accent: #D63384;
    --color-accent-hover: #B02A6B;
    --color-border: #E8D5E8;
    --color-card-bg: #ffffff;
    --color-hover-bg: #F8F0F8;

    
    /* Font variables for different text elements */
    --font-display-heading: 'DM Serif Display', Georgia, serif; /* Main titles, h1 */
    --font-heading: 'Playfair Display', Georgia, serif; /* Section headings, h2-h6 */
    --font-body: 'Lora', Georgia, serif; /* Paragraphs and content */
    --font-ui: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; /* Buttons, labels, interface */
    
    --max-width: 1000px;
    --max-width-wide: 1100px;
  }

  html {
    font-size: 18px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }

  body {
    font-family: var(--font-body);
    color: var(--color-text);
    background-color: var(--color-bg);
    line-height: 1.6;
    font-weight: 400;
    letter-spacing: -0.01em;
    overflow-x: hidden;
    position: relative;
    width: 100%;
    cursor: none;
  }

  h1 {
    font-family: var(--font-display-heading);
    font-size: 3.5rem;
    font-weight: 400;
    line-height: 1.1;
    margin-bottom: 1rem;
    letter-spacing: -0.04em;
  }

  h2, h3, h4, h5, h6 {
    font-family: var(--font-heading);
    font-weight: 400;
    line-height: 1.1;
    margin-bottom: 1rem;
    letter-spacing: -0.03em;
  }

  h2 {
    font-size: 2.5rem;
    letter-spacing: -0.03em;
  }

  h3 {
    font-size: 1.875rem;
  }

  h4 {
    font-size: 1.5rem;
  }

  p {
    margin-bottom: 1.5rem;
    line-height: 1.8;
  }

  a {
    color: var(--color-accent);
    text-decoration: none;
    transition: color 0.2s ease;
    
    &:hover {
      color: var(--color-accent-hover);
      text-decoration: underline;
    }
  }

  blockquote {
    font-family: var(--font-body);
    font-style: italic;
    font-size: 1.25rem;
    line-height: 1.6;
    margin: 2rem 0;
    padding: 0 2rem;
    border-left: 4px solid var(--color-accent);
    color: var(--color-text-light);
  }

  code {
    font-family: 'Monaco', 'Consolas', monospace;
    font-size: 0.875rem;
    background: rgba(0, 0, 0, 0.05);
    padding: 0.125rem 0.375rem;
    border-radius: 4px;
  }

  pre {
    background: #1a1a1a;
    color: #f8f8f2;
    padding: 1.5rem;
    border-radius: 8px;
    overflow-x: auto;
    margin-bottom: 1.5rem;
    
    code {
      background: none;
      padding: 0;
      color: inherit;
    }
  }

  button {
    font-family: var(--font-ui);
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  input, textarea, select {
    font-family: var(--font-ui);
    font-size: 1rem;
  }

  ::selection {
    background-color: var(--color-accent);
    color: white;
  }

  /* Global overflow prevention */
  #root {
    overflow-x: hidden;
    width: 100%;
    max-width: 100vw;
  }

  @media (max-width: 768px) {
    html {
      font-size: 16px;
    }
    
    h1 {
      font-size: 2.5rem;
    }
    
    h2 {
      font-size: 2rem;
    }
    
    h3 {
      font-size: 1.5rem;
    }
  }
`;
